// api/geo.js
import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

/**
 * Fetch all supported countries (private endpoint)
 * JWT auth is required
 */
export const fetchCountries = async () => {
  try {
    const response = await client.get("/geo/countries");
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch subdivisions (provinces/territories) for a given country
 * @param {string} countryIso2 e.g. "CA"
 */
export const fetchSubdivisions = async (countryIso2) => {
  try {
    const response = await client.get(`/geo/${countryIso2}/subdivisions`);
    return response.data;
  } catch (error) {
    throw error;
  }
};